import DuckEntity from './DuckEntity';

const duck = new DuckEntity('reviewDocuments');

/**
 * Fetches the file URL for a document, an uploaded PDF or image for example.
 *
 * This URL is expiring and should be used immediately.
 *
 * @param document {object} review document
 * @return {Promise<any>} resolves to file URL
 */
export const fetchUrl = (document) => {
  return fetch(document.document_url)
    .then(response => response.json())
    .then(data => data.file_url);
};

/**
 * Downloads the file for a document, an uploaded PDF or image for example.
 *
 * @param document {object} review document
 */
export const download = (document) => {
  fetchUrl(document).then(url => {
    window.location = url;
  });
};

const entity = {
  ...duck,
  download,
  fetchUrl,
};

export { entity };
